export default class SuperElement {
    constructor(obj) {
        this.obj = obj;

        this.currentHtml = this.obj.html();
        this.currentStyle = this.obj.attr('style');
    }

    getContainer() {
        var container = this.obj.closest('[builder-element=BlockElement]');

        // throws exception if can not find container
        if (!container.length) {
            console.warn('Selected element dose not have container (BlockElement)!');
            return null;
        }

        // if can find container and
        if (this.obj.attr('builder-element') != 'BlockElement') {
            return new BlockElement(container);
        } else {
            return null;
        }
    }

    getParentElements() {
        return [];
    }

    getCellContainer() {
        var container = this.obj.closest('[builder-element=CellContainerElement]');

        // not found cell container
        if (!container.length) {
            return null;
        }

        // if can find container and
        if (this.obj.attr('builder-element') != 'CellContainerElement') {
            return new CellContainerElement(container);
        } else {
            return null;
        }
    }

    canSelect() {
        return true;
    }

    canHover() {
        return true;
    }

    name() {
        return this.obj.prop("tagName");
    }

    icon() {
        return 'fa fa-code';
    }

    isContainer() {
        return false;
    }

    isWrapper() {
        return false;
    }

    canDelete() {
        return true;
    }

    canDuplicate() {
        return true;
    }

    isInlineEdit() {
        return this.obj.is('[builder-inline-edit]');
    }

    isFullRow() {
        return this.obj.offset().left < 20;
    }

    showControls() {
        return (!this.isWrapper() && !getDragAndDropEnabled());
    }

    isDraggable() {
        return !currentEditor.strict;
    }

    // START - DRAG & DROP INTERFACE ============

    // get drop HTML
    dropHtml() {
        return $('<div>').append(this.obj.clone()).html();
    }

    dragHtml() {

        return `
            <div class="widget-moving-shadow">
                <div class="_1content widget-text" title="{language.wpanel.others.dragtomove.name}">
                    <div class="panel__body" title="{language.wpanel.widgets.title.title}">
                        <span class="widget-custom-tag"><i class="{builder-icon-user}"></i></span>
                        <span class="remove-widget-button"><i class="{builder-icon-trash-alt}"></i></span>
                        <div class="image-drag">
                            <div ng-bind-html="::getModuleIcon(module)" class="ng-binding">
                                <i class="{builder-icon-code}" style="font-size: 36px;display: inline-block;"></i>
                            </div>
                        </div>
                        <div class="body__title">${getI18n('wpanel.others.dragtomove.name')}</div>
                    </div>
                </div>
            </div>
        `;

    }

    hasBlockContainer() {
        return true;
    }
    // END - DRAG & DROP INTERFACE ============


    // Select outline
    selectOutline() {
        return $("#builder_iframe").contents().find("body").find('.builder-select-outline');
    }

    // Load Select outline
    loadSelectOutline() {
        // check if outline is already exist

        if (this.selectOutline().length == 0) {
            console.log ('Select outline does not exists');
            // outline controls html
            var outline = $(`
                <div class="builder-tool builder-select-outline" style="display: none;"></div>
            `);

            $("#builder_iframe").contents().find("body").append(outline);
            outline.fadeIn(200);
        }else{
            console.log ('Select outline already exists');
        }
    }

    // remove select outline
    removeSelectOutline() {
        // remove outline
        this.selectOutline().remove();
    }


    selectControls() {
        //console.log ("Removing selected controls");
        return $("#builder_iframe").contents().find("body").find('.builder-outline-selected-controls');
    }

    loadSelectControls(isTopLevel) {
        let hideTextMenu = sessionStorage.getItem('hideTextMenu');
        hideTextMenu = true;
        if (hideTextMenu !== null && hideTextMenu === 'true') return;
        // check if outline is already exist
        if (this.selectControls().length == 0) {
            var html = $('<div>').append($('.builder-outline-selected-controls').clone()).html();


            // outline controls html
            var controls = $(html);

            $("#builder_iframe").contents().find("body").append(controls);
        }

        if (!isTopLevel) {
            this.selectControls().find('.builder-outline-move-hook').hide();
            this.selectControls().find('.builder-ai-selected-button').hide();
        } else {
            this.selectControls().find('.builder-outline-move-hook').show();
            this.selectControls().find('.builder-ai-selected-button').show();
        }

        if (!this.canDelete()) {
            this.selectControls().find('.builder-remove-selected-button').hide();
        } else {
            this.selectControls().find('.builder-remove-selected-button').show();
        }

        if (!this.canDuplicate()) {
            this.selectControls().find('.builder-duplicate-selected-button').hide();
        } else {
            this.selectControls().find('.builder-duplicate-selected-button').show();
        }

    }

    adjustSelectControlsPosition(scale) {

        var multiplier = (scale && scale > 1) ? 1 : (scale || 1);
        var selectedControlsMultiplier = (multiplier >= 1) ? 1 : (multiplier < window.minimumMobileCtxBarScale ? window.minimumMobileCtxBarScale : scale);
        const $iframeContents = $("#builder_iframe").contents().find('#maincontent-body-html');
        const outlineblue = $iframeContents.find('#selectedborder')[0];

        if (outlineblue) {
            const isHoverable = window.matchMedia("(hover: hover) and (pointer: fine)").matches;
            const $outlineblue = $(outlineblue);
            const divOffset = $outlineblue.offset(); // Top-left corner of outlineblue
            const divWidth = $outlineblue.outerWidth(true) * multiplier; // Full width of outlineblue including padding/border

            if (divOffset) {
                const $selectControls = this.selectControls();

                // Keep the top position unchanged
                const topPosition = divOffset.top - ($selectControls.outerHeight() * multiplier + 10 * multiplier);
                $selectControls.css('top', topPosition);

                // Adjust left position for viewport zoom
                const vp = window.visualViewport || {
                    offsetLeft: 0,
                    width: window.innerWidth,
                    scale: 1,
                };

                const selectControlsWidth = $selectControls.outerWidth() * selectedControlsMultiplier;

                // Adjust the width to avoid cutting off for larger devices
                const extraPadding = vp.scale > 1 ? Math.min(100 / vp.scale, 10) : 0;


                // Adjusted left position with clamping
                const adjustedLeft = Math.max(
                    vp.offsetLeft + extraPadding, // Ensure it doesn't go out of the viewport on the left
                    Math.min(
                        divOffset.left + divWidth - selectControlsWidth - extraPadding, // Calculate right alignment with padding
                        vp.offsetLeft + vp.width - selectControlsWidth - extraPadding // Ensure it doesn't go out of the viewport on the right
                    )
                );
                if (isHoverable) {
                    $selectControls.css('left', adjustedLeft);
                }
                else {
                    const vwscale = 1 / (vp?.scale || 1);
                    $selectControls.css('transform', `scale(${vwscale})`);

                    const ctxContextBar = $selectControls;

                    const X_OFFSET = 0; // Horizontal offset
                    // Get the width and height of the bar using jQuery
                    const barWidth = ctxContextBar.outerWidth();

                    const barHeight = topPosition < 40 ? -40 * vwscale : topPosition < 60 ? 50 * vwscale : 70 * vwscale;// 32 is the height in .ctx-slider { style add 28 as more offset

                    const normalizedXOffset = X_OFFSET / (vp.scale || 1);
                    const left = vp.offsetLeft + (vp.width - barWidth) / 2 + normalizedXOffset;



                    // Update the position of the context bar using jQuery
                    ctxContextBar.css({
                        left: `${left}px`,
                        top: `${topPosition - barHeight}px`
                    });

                    $selectControls.css('display', '');

                    this.cleanupContextBarListeners();

                    this.attachContextBarListeners(ctxContextBar);

                }


            } else {
                console.error("divOffset is undefined.");
            }
        }
    }

    attachContextBarListeners(ctxContextBar) {
        const ctxSliderContent = ctxContextBar.find("#ctxSliderContent")[0];
        const ctxArrowLeft = ctxContextBar.find("#ctxArrowLeft")[0];
        const ctxArrowRight = ctxContextBar.find("#ctxArrowRight")[0];
        window.ctxUndoBtn =  ctxContextBar.find("#ctxUndoBtn")[0];
        window.ctxRedoBtn =  ctxContextBar.find("#ctxRedoBtn")[0];

        this.updateUndoRedoButtons();

        if (!ctxSliderContent || !ctxArrowLeft || !ctxArrowRight) {
            console.error("Required elements not found in the context bar.");
            return;
        }

       // Scroll left functionality
        const scrollLeftHandler = (e) => {
            e.preventDefault();
            const scrollLeft = ctxSliderContent.scrollLeft;
            const scrollAmount = Math.min(100, scrollLeft); // Scroll only the remaining distance to the start
            ctxSliderContent.scrollBy({ left: -scrollAmount, behavior: "smooth" });
        };

        // Scroll right functionality
        const scrollRightHandler = (e) => {
            e.preventDefault();
            const scrollLeft = ctxSliderContent.scrollLeft;
            const maxScrollLeft = ctxSliderContent.scrollWidth - ctxSliderContent.clientWidth;
            const scrollAmount = Math.min(100, maxScrollLeft - scrollLeft); // Scroll only the remaining distance to the end
            ctxSliderContent.scrollBy({ left: scrollAmount, behavior: "smooth" });
        };

        // Adjust visibility of arrows based on scroll position
        const scrollVisibilityHandler = () => {
            const scrollLeft = ctxSliderContent.scrollLeft;
            const maxScrollLeft = ctxSliderContent.scrollWidth - ctxSliderContent.clientWidth;

            ctxArrowLeft.style.visibility = scrollLeft > 30 ? "visible" : "hidden";
            ctxArrowRight.style.visibility = scrollLeft < maxScrollLeft -30  ? "visible" : "hidden";

        };

        // Attach listeners
        ctxArrowLeft.addEventListener("click", scrollLeftHandler);
        ctxArrowRight.addEventListener("click", scrollRightHandler);
        ctxSliderContent.addEventListener("scroll", scrollVisibilityHandler);

        // Store listeners in ctxbarListeners for cleanup
        window.ctxbarListeners.push(
            { target: ctxArrowLeft, event: "click", handler: scrollLeftHandler },
            { target: ctxArrowRight, event: "click", handler: scrollRightHandler },
            { target: ctxSliderContent, event: "scroll", handler: scrollVisibilityHandler }
        );

        // Initialize visibility of arrows
        ctxSliderContent.dispatchEvent(new Event("scroll"));
    }


    updateUndoRedoButtons() {
        // Update Undo button state
        if (window.ctxUndoBtn) {
            if (window.canUndo) {
                $(window.ctxUndoBtn).removeClass('disabled');
            } else {
                $(window.ctxUndoBtn).addClass('disabled');
            }
        }

        // Update Redo button state
        if (window.ctxRedoBtn) {
            if (window.canRedo) {
                $(window.ctxRedoBtn).removeClass('disabled');
            } else {
                $(window.ctxRedoBtn).addClass('disabled');
            }
        }
    }



    cleanupContextBarListeners() {
        if (window.ctxbarListeners && window.ctxbarListeners.length > 0) {
            // Iterate through all stored listeners and remove them
            window.ctxbarListeners.forEach(({ target, event, handler }) => {
                if (target) {
                    target.removeEventListener(event, handler);
                }
            });
            // Clear the ctxbarListeners array
            window.ctxbarListeners.length = 0;
        } else {
            console.log("No listeners found to clean up.");
        }
    }




    // adjustSelectControlsPosition(scale) {
    //     // const mainTableDiv= $("#builder_iframe").contents().find("body").find('.tox-edit-area').find('#PageElement_ifr').contents().find('html').find('#main-table')[0];
    //     // var multiplier = mainTableDiv.getAttribute('data');
    //     // if (multiplier) multiplier = parseFloat(multiplier);
    //     // else multiplier=1.0;
    //     var multiplier=1;
    //     if (scale) multiplier=scale;

    //     const outlineblue=  $("#builder_iframe").contents().find('#maincontent-body-html').find('#selectedborder')[0];


    //     var divOffset = $(outlineblue).offset();
    //     var divWidth = $(outlineblue).width();
    //     var divHeight = $(outlineblue).height();

    //     this.selectControls().css('top', divOffset.top + divHeight*multiplier -2 - 1/multiplier ); //1/multiplier is used to reduce the top
    //     this.selectControls().css('left', divOffset.left  + this.obj.outerWidth()*multiplier  - this.selectControls().outerWidth()*multiplier -3 +  13*multiplier);

    //     // if (this.isFullRow()) {
    //     //     this.selectControls().css('left', this.obj.offset().left  + this.obj.outerWidth()  - this.selectControls().outerWidth() + 5 + ($("#builder_iframe").contents().find("body").find('.tox-edit-area')).offset().left);
    //     // }

    //     // if (this.selectControls().offset().top + this.selectControls().outerHeight() > $("#builder_iframe").outerHeight()) {
    //     //     this.selectControls().css('top', this.obj.offset().top  + this.obj.outerHeight() + 0 - this.selectControls().outerHeight() - 8   +  ($("#builder_iframe").contents().find("body").find('.tox-edit-area')).offset().top) ;
    //     //     this.selectControls().css('left', this.obj.offset().left + this.obj.outerWidth() + 5 - this.selectControls().outerWidth() - 3  + ($("#builder_iframe").contents().find("body").find('.tox-edit-area')).offset().left);
    //     // }
    // }

    removeSelectControls() {
        this.selectControls().remove();
    }

    // selectMoveButton() {
    //     return $("#builder_iframe").contents().find("body").find('.builder-outline-move-hook');
    // }

    // loadSelectMoveButton() {
    //     // check if outline is already exist
    //     if (this.selectMoveButton().length == 0 && this.isDraggable()) {
    //         var html = $('<div>').append($('.builder-outline-move-hook').clone()).html();

    //         // outline controls html
    //         var controls = $(html);

    //         $("#builder_iframe").contents().find("body").append(controls);
    //     }
    // }

    selectBorder() {
        return $("#builder_iframe").contents().find("body").find('.builder-outline-blue');
    }

    loadBorder() {
        let hideTextMenu = sessionStorage.getItem('hideTextMenu');
        if (hideTextMenu !== null && hideTextMenu === 'true') return;
        // check if outline is already exist
        if (this.selectBorder().length == 0) {
            var html = $('<div>').append($('.builder-outline-blue').clone()).html();

            // outline controls html
            var border = $(html);

            $("#builder_iframe").contents().find("body").append(border);
            // const mainTableDiv= $("#builder_iframe").contents().find("body").find('.tox-edit-area').find('#PageElement_ifr').contents().find('html').find('#main-table')[0];
            // var multiplier = mainTableDiv.getAttribute('data');
            // if (multiplier) multiplier = parseFloat(multiplier);
            // else multiplier=1.0;
            // console.log ('multiplier is:', multiplier);

            // const borderSize = $("#selectedborder").css("border-width");
            // $("#selectedborder").css({
            //     border: "20px solid green !important",
            //     transform: "scale(" + multiplier + ")",
            //     borderWidth: borderSize / multiplier + "px" // Adjust border width based on scale
            // });
        }

    }



    // adjustBorderPosition() {
    //     if (this.isDraggable() && this.obj && ($("#builder_iframe").contents().find("body").find('.tox-edit-area'))) {
    //       //  this.selectMoveButton().css('top', this.obj.offset().top  +  ($("#builder_iframe").contents().find("body").find('.tox-edit-area')).offset().top  +  (this.obj.outerHeight()/2) - (this.selectMoveButton().outerHeight()/2));
    //       this.selectBorder().css('top', this.obj.offset().top  +  (($("#builder_iframe").contents().find("body").find('.tox-edit-area')) ? ((($("#builder_iframe").contents().find("body").find('.tox-edit-area')).offset().top -5)):0));
    //       this.selectBorder().css('left', this.obj.offset().left + (($("#builder_iframe").contents().find("body").find('.tox-edit-area')) ? ((($("#builder_iframe").contents().find("body").find('.tox-edit-area')).offset().left -5)):0));
    //       this.selectBorder().css('width', this.obj.outerWidth() + 10);
    //       this.selectBorder().css('height', this.obj.outerHeight());

    //         // // out of right side
    //         // if (this.selectMoveButton().offset().left + this.selectMoveButton().outerWidth() > $("#builder_iframe").outerWidth()) {
    //         //     this.selectMoveButton().css('left', $("#builder_iframe").outerWidth() - this.selectMoveButton().outerWidth());
    //         //     this.selectMoveButton().css('border-radius', '50% 0 0 50%');
    //         // }


    //     }
    // }

    adjustBorderPosition(scale) {
        var multiplier = scale || 1; // Default multiplier to 1 if scale is not provided
        if (this.isDraggable() && this.obj) {
            const $iframeContents = $("#builder_iframe").contents().find("body");
            const $toxEditArea = $iframeContents.find('.tox-edit-area');

            if (this.obj.offset()) {
                const topOffset = $toxEditArea.length > 0 ? ($toxEditArea.offset().top - 5) : 0;
                const leftOffset = $toxEditArea.length > 0 ? ($toxEditArea.offset().left - 5) : 0;

                this.selectBorder().css('top', this.obj.offset().top + topOffset);
                this.selectBorder().css('left', this.obj.offset().left + leftOffset);
                this.selectBorder().css('width', this.obj.outerWidth() + 8 + 5 / multiplier);
                this.selectBorder().css('height', this.obj.outerHeight());
            } else {
                console.error("this.obj.offset() is undefined.");
            }
        }
    }

    adjustSelectMoveButtonPosition(scale) {
        if (this.isDraggable()) {
            var multiplier = scale || 1;  // Default to 1 if scale is not provided

            const $iframeContents = $("#builder_iframe").contents().find('#maincontent-body-html');
            const outlineblue = $iframeContents.find('#selectedborder')[0];

            if (outlineblue) {
                const $outlineblue = $(outlineblue);
                const divOffset = $outlineblue.offset();
                const divWidth = $outlineblue.width();
                const divHeight = $outlineblue.height();

                if (divOffset) {
                    this.selectMoveButton().css('top', divOffset.top - (this.selectMoveButton().outerHeight() * multiplier));
                    this.selectMoveButton().css('left', divOffset.left + this.obj.outerWidth() * multiplier - (this.selectMoveButton().outerWidth() * multiplier) + 10 * multiplier);
                } else {
                    console.error("divOffset is undefined.");
                }
            } else {
                console.error("#selectedborder element not found.");
            }
        }
    }


    // commented this out as it was getting error when clicked form resume to the home page any blank space, this is fixed by above code from chatgpt
    // adjustSelectMoveButtonPosition(scale) {
    //     if (this.isDraggable()) {

    //         // const mainTableDiv= $("#builder_iframe").contents().find("body").find('.tox-edit-area').find('#PageElement_ifr').contents().find('html').find('#main-table')[0];
    //         // var multiplier = mainTableDiv.getAttribute('data');
    //         // if (multiplier) multiplier = parseFloat(multiplier);
    //         // else multiplier=1.0;
    //         var multiplier=1;
    //         if (scale) multiplier=scale;

    //         const outlineblue=  $("#builder_iframe").contents().find('#maincontent-body-html').find('#selectedborder')[0];


    //         var divOffset = $(outlineblue).offset();
    //         var divWidth = $(outlineblue).width();
    //         var divHeight = $(outlineblue).height();


    //       //  this.selectMoveButton().css('top', this.obj.offset().top  +  ($("#builder_iframe").contents().find("body").find('.tox-edit-area')).offset().top  +  (this.obj.outerHeight()/2) - (this.selectMoveButton().outerHeight()/2));
    //       this.selectMoveButton().css('top', divOffset.top - (this.selectMoveButton().outerHeight()*multiplier));
    //       this.selectMoveButton().css('left', divOffset.left + this.obj.outerWidth()*multiplier  - (this.selectMoveButton().outerWidth()*multiplier) + 10*multiplier); //4/multiplier is used to reduce the left

    //         // // out of right side
    //         // if (this.selectMoveButton().offset().left + this.selectMoveButton().outerWidth() > $("#builder_iframe").outerWidth()) {
    //         //     this.selectMoveButton().css('left', $("#builder_iframe").outerWidth() - this.selectMoveButton().outerWidth());
    //         //     this.selectMoveButton().css('border-radius', '50% 0 0 50%');
    //         // }

    //         // if (this.isFullRow()) {
    //         //     this.selectMoveButton().css('top', this.obj.offset().top  +  ($("#builder_iframe").contents().find("body").find('.tox-edit-area')).offset().top   - 1 - (this.selectMoveButton().outerHeight()/2));
    //         //     this.selectMoveButton().css('left', this.obj.offset().left + ($("#builder_iframe").contents().find("body").find('.tox-edit-area')).offset().left + 0 + this.obj.outerWidth() - (this.selectMoveButton().outerWidth()));

    //         //     this.selectMoveButton().css('left', this.obj.offset().left + ($("#builder_iframe").contents().find("body").find('.tox-edit-area')).offset().left + 0 + this.obj.outerWidth() - (this.selectMoveButton().outerWidth()) + 6 - 19);
    //         // }
    //     }
    // }

    // removeSelectMoveButton() {
    //     this.selectMoveButton().remove();
    // }

    removeBorder() {
        this.selectBorder().remove();
    }

    // select element
    select(scale, isTopLevel) {

        // console.log ("Element selected again")
        // add select highlight class
        this.obj.addClass('builder-class-element-selected');

        // console.log ("the object in select super element is", this.obj);

        // load select outline
        //  this.loadSelectOutline();

        // adjust select outline position
        //  this.adjustSelectOutlinePosition();

        // if wrapper --> not show controls
        if (this.showControls()) {

            this.loadBorder(); // Call the function
            this.adjustBorderPosition(scale);

            // load select controls
            this.loadSelectControls(isTopLevel);

            // adjust select controls position
            this.adjustSelectControlsPosition(scale);

        }

        // if (this.isDraggable()) {
        //     // load select move button
        //     this.loadSelectMoveButton();

        //     // adjust select move button
        //     this.adjustSelectMoveButtonPosition(scale);
        // }

    }

    // unselect element
    unselect() {


        this.obj.removeClass('builder-class-element-selected');

        // if wrapper --> not show controls
        if (this.showControls()) {
            // remove select controls
            this.removeSelectControls();
        }

        // remove lobal
        // this.removeSelectMoveButton();

        // remove uotline
        this.removeSelectOutline();

        this.removeBorder();

        if (typeof (this.unselectCallback) !== 'undefined') {
            this.unselectCallback();
        }
    }

    getControls() {
        return [
        ];
    }

    equals(element) {
        if (element == null) {
            return false;
        }

        return this.obj.is(element.obj);
    }

    // drop outline
    dropOutline() {
        return $("body").find('.builder-drop-outline');
    }

    // Load drop outline
    loadDropOutline() {
        // check if outline is already exist
        if (this.dropOutline().length == 0) {
            // outline controls html
            var outline = $(`
                <div class="builder-tool builder-drop-outline" style= " position: absolute !important; top: 200px !important; left: 100px; width: 100px; height: 10px;pointer-events: none; background-color: #ffffff;
                opacity: 0.5;
                box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.3);
                border-radius: 5px;"></div>
            `);

            $("body").append(outline);
        }
    }

    // remove drop outline
    removeDropOutline() {
        // remove outline
        this.dropOutline().remove();
    }

    // adjust hover outline position
    adjustDropOutlinePosition() {

        this.dropOutline().css({
            top: this.obj.offset().top + ($("#builder_iframe").contents().find("body").find('.tox-edit-area')).offset().top + window.parent.document.getElementById('builder_iframe').offsetTop - $("#builder_iframe").contents().find('html').scrollTop(),
            height: this.obj.outerHeight(),
            width: this.obj.outerWidth(),
            left: this.obj.offset().left + ($("#builder_iframe").contents().find("body").find('.tox-edit-area')).offset().left + window.parent.document.getElementById('builder_iframe').offsetLeft

        });
    }



    // hightlight element
    afterHighlight() {

        // load drop outline
        this.loadDropOutline();

        // adjust drop outline position
        this.adjustDropOutlinePosition();

    }

    // unhighlight
    afterUnHighlight() {

        // remove drop outline
        this.removeDropOutline();

        // remove highlight
        this.removeDropAfterOutline();
    }



    // hightlight element
    beforeHighlight() {
        // remove after if exist
        this.removeDropAfterOutline();

        // load drop outline
        this.loadDropOutline();

        // adjust drop outline position
        this.adjustDropOutlinePosition();

        // add after outline
        this.loadDropBeforeOutline();

        // adjust outline position
        // this.adjustDropBeforeOutlinePosition();
    }

    dropAfterOutline() {
        return $("#builder_iframe").contents().find("body").find('.drop-element-after-hover');
    }

    loadDropAfterOutline() {
        // check if outline is already exist
        if (this.dropAfterOutline().length == 0) {
            // outline controls html
            var outline = $('<div class="builder-tool drop-element-after-hover">' +
                '<span>' + getI18n('drag_here') + '</span>' +
                '</div>');

            $("#builder_iframe").contents().find("body").append(outline);
        }

        this.obj.addClass('builder-drop-after-element');
    }

    adjustDropAfterOutlinePosition() {
        this.dropAfterOutline().css('top', this.obj.offset().top + this.obj.outerHeight() - 2 + parseInt(this.obj.css('margin-bottom')));
        this.dropAfterOutline().css('left', this.obj.offset().left);

        this.dropAfterOutline().css('width', this.obj.outerWidth());
    }

    removeDropAfterOutline() {
        this.dropAfterOutline().remove();
        this.obj.removeClass('builder-drop-after-element');
    }

    dropBeforeOutline() {
        return $("#builder_iframe").contents().find("body").find('.drop-element-before-hover');
    }

    // load drop before outline
    loadDropBeforeOutline() {
        // check if outline is already exist
        if (this.dropBeforeOutline().length == 0) {
            // outline controls html
            var outline = $('<div class="builder-tool drop-element-before-hover">' +
                '<span>' + getI18n('drag_here') + '</span>' +
                '</div>');

            $("#builder_iframe").contents().find("body").append(outline);
        }

        this.obj.addClass('builder-drop-before-element');
    }

    adjustDropBeforeOutlinePosition() {
        this.dropBeforeOutline().css('top', this.obj.offset().top);
        this.dropBeforeOutline().css('left', this.obj.offset().left);

        this.dropBeforeOutline().css('width', this.obj.outerWidth());
    }

    removeDropBeforeOutline() {
        this.dropBeforeOutline().remove();
        this.obj.removeClass('builder-drop-before-element');
    }


    // unhighlight
    beforeUnHighlight() {

        // load drop outline
        this.removeDropOutline();

        // remove highlight
        this.removeDropBeforeOutline();
    }

    removeDropBeforeOutline() {
        this.dropBeforeOutline().remove();
        this.obj.removeClass('builder-drop-before-element');
    }

    adjustDropBeforeOutlinePosition() {
        this.dropBeforeOutline().css('top', this.obj.offset().top);
        this.dropBeforeOutline().css('left', this.obj.offset().left);

        this.dropBeforeOutline().css('width', this.obj.outerWidth());
    }

    loadDropBeforeOutline() {
        // check if outline is already exist
        if (this.dropBeforeOutline().length == 0) {
            // outline controls html
            var outline = $('<div class="builder-tool drop-element-before-hover">' +
                '<span>' + getI18n('drag_here') + '</span>' +
                '</div>');

            $("#builder_iframe").contents().find("body").append(outline);
        }

        this.obj.addClass('builder-drop-before-element');
    }


    removeDropAfterOutline() {
        this.dropAfterOutline().remove();
        this.obj.removeClass('builder-drop-after-element');
    }


    // check target position
    checkTargetPosition(e) {
        var obj_height = this.obj.height();
        var obj_top = this.obj.offset().top + ($("#builder_iframe").contents().find("body").find('.tox-edit-area')).offset().top;
        var mouse_top = e.pageY;

        var pos = mouse_top - obj_top;

        if (pos < obj_height / 2) {
            return 'before';
        } else {
            return 'after';
        }
    }

    // Drop inside label
    dropInsideOutline() {
        return $("#builder_iframe").contents().find("body").find('.builder-drop-inside-outline');
    }

    // Load drop inside outline
    loadDropInsideOutline() {
        // check if outline is already exist
        if (this.dropInsideOutline().length == 0) {
            // outline controls html
            var outline = $(`
                <div class="builder-tool builder-drop-inside-outline"></div>
            `);

            $("#builder_iframe").contents().find("body").append(outline);
        }
    }

    // remove drop inside outline
    removeDropInsideOutline() {
        // remove outline
        this.dropInsideOutline().remove();
    }

    // adjust hover outline position
    adjustDropInsideOutlinePosition() {
        // top
        //var width = 3;
        this.dropInsideOutline().css({
            top: this.obj.offset().top + ($("#builder_iframe").contents().find("body").find('.tox-edit-area')).offset().top,
            height: this.obj.outerHeight(),
            width: this.obj.outerWidth(),
            left: this.obj.offset().left + ($("#builder_iframe").contents().find("body").find('.tox-edit-area')).offset().left,
        });
    }

    dropInsideLabel() {
        return $("#builder_iframe").contents().find("body").find('.drop-inside-label-hover');
    }

    // load drop before outline
    loadDropInsideLabel() {
        // check if outline is already exist
        if (this.dropInsideLabel().length == 0) {
            // outline controls html
            var outline = $('<div class="builder-tool drop-inside-label-hover">' +
                '<span>' + getI18n('drag_here') + '</span>' +
                '</div>');

            $("#builder_iframe").contents().find("body").append(outline);
        }
    }

    adjustDropInsideLabelPosition() {
        this.dropInsideLabel().css('top', this.obj.offset().top + +  ($("#builder_iframe").contents().find("body").find('.tox-edit-area')).offset().top + this.dropInsideLabel().outerHeight());
        this.dropInsideLabel().css('left', this.obj.offset().left + ($("#builder_iframe").contents().find("body").find('.tox-edit-area')).offset().left);

        this.dropInsideLabel().css('width', this.obj.outerWidth());
    }

    removeDropInsideLabel() {
        this.dropInsideLabel().remove();
    }

    //
    dropInsideHighlight() {
        // load drop outline
        this.loadDropInsideOutline();

        // adjust drop outline position
        this.adjustDropInsideOutlinePosition();

        // load drop label
        this.loadDropInsideLabel();

        // adjust drop label position
        this.adjustDropInsideLabelPosition();
    }
}